import { enableProdMode } from '@angular/core';
import { LicenseManager } from 'ag-grid-enterprise';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AgCharts } from 'ag-charts-enterprise';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isBetween from 'dayjs/plugin/isBetween';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import utc from 'dayjs/plugin/utc';

if (environment.production) {
	enableProdMode();
}

const license =
	// eslint-disable-next-line max-len
	'Using_this_{AG_Charts_and_AG_Grid}_Enterprise_key_{AG-087494}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{IDS_Gov_Services_Pty_Ltd}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{VM_Online}_only_for_{10}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{VM_Online}_need_to_be_licensed___{VM_Online}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Charts_and_AG_Grid}_Enterprise_versions_released_before_{30_June_2026}____[v3]_[0102]_MTc4Mjc3NDAwMDAwMA==74974a6ced7e7815b5dd29f554775dad';

LicenseManager.setLicenseKey(license);
AgCharts.setLicenseKey(license);

dayjs.extend(customParseFormat);
dayjs.extend(isBetween);
dayjs.extend(isSameOrAfter);
dayjs.extend(utc);

platformBrowserDynamic()
	.bootstrapModule(AppModule)
	.catch((err) => console.error(err));
